import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import {
    FILTER_NAMES,
    generalFiltersBlockStyle,
    useMediaQueries
} from "shared";

import FilterButton from "../components/FilterButton";
import FilterMenu from "../components/FilterMenu";
import FilterDropdown from "../FilterDropdown";
import { useFilters } from "../hooks";

export const TaskGroupDetailTaskFilters = () => {
    const { hasNoPermissionToRead, innerTableQueryParams } =
        useContext(TableContext);

    const { t } = useTranslation();
    const { toLg, fromLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    const additionalParams = `${[FILTER_NAMES.BatchId]}=${innerTableQueryParams[FILTER_NAMES.BatchId]}`;

    return (
        <div css={css(generalFiltersBlockStyle)}>
            {fromLg && (
                <FilterDropdown
                    filter={FILTER_NAMES.TaskStatus}
                    placeholder={t(`Filter##${FILTER_NAMES.TaskStatus}`)}
                    disabled={hasNoPermissionToRead}
                    additionalParams={additionalParams}
                    css={css({ marginRight: "16px" })}
                />
            )}

            <FilterButton
                onOpen={handleOpenMenu}
                isDisabled={hasNoPermissionToRead}
            >
                {fromLg ? t("Button##more filters") : t("Button##filters")}
            </FilterButton>

            <FilterMenu
                isOpen={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCloseMenu}
            >
                <div
                    css={css({
                        "& > div + div": {
                            marginTop: "12px"
                        }
                    })}
                >
                    {toLg && (
                        <FilterDropdown
                            filter={FILTER_NAMES.TaskStatus}
                            placeholder={t(
                                `Filter##${FILTER_NAMES.TaskStatus}`
                            )}
                            additionalParams={additionalParams}
                        />
                    )}

                    <FilterDropdown
                        filter={FILTER_NAMES.CompanyId}
                        placeholder={t(`Filter##${FILTER_NAMES.CompanyId}`)}
                        additionalParams={additionalParams}
                        shouldIgnoreCompanySelector
                    />

                    <FilterDropdown
                        filter={FILTER_NAMES.Model}
                        placeholder={t(`Filter##${FILTER_NAMES.Model}`)}
                        additionalParams={additionalParams}
                    />
                </div>
            </FilterMenu>
        </div>
    );
};
